import { render, staticRenderFns } from "./freeplaces.vue?vue&type=template&id=14df6b42&scoped=true"
import script from "./freeplaces.vue?vue&type=script&lang=js"
export * from "./freeplaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14df6b42",
  null
  
)

export default component.exports